import { render, staticRenderFns } from "./CEComponent.vue?vue&type=template&id=64ba5c0c"
import script from "./CEComponent.vue?vue&type=script&lang=js"
export * from "./CEComponent.vue?vue&type=script&lang=js"
import style0 from "./CEComponent.vue?vue&type=style&index=0&id=64ba5c0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports